/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const productRecommendationSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "productRecommendation",

  initialState: {
    first: {
      productRecommendations: [],

      // productRecommendations: [
      //   {
      //     //PRODUCT
      //     proposer: "",
      //     lifeAssured: "",
      //     need: "",

      //     //PRODUCT DETAILS
      //     companyId: "",
      //     companyName: "",
      //     productCategoryId: "",
      //     productCategory: "",
      //     productId: "",
      //     productName: "",
      //     sumAssured: "",
      //     paymentFrequency: "",
      //     premium: "",
      //     premiumTerm: "",
      //     policyTerm: "",
      //     settlementMode: "",

      //     //MULTIPLIER
      //     addMultiplier: "",
      //     multiplier: {
      //       policyIllustration: "",
      //       prodMultiplierBenefitType: "",
      //       prodMultiplierBenefit: "",
      //       prodMultiplierPremium: "",
      //       prodMultiplierPremiumTerm: "",
      //       prodMultiplierPolicyTerm: "",
      //     },

      //     //RIDERS
      //     riderOnly: "",
      //     riders: [
      //       {
      //         riderId: "",
      //         riderName: "",
      //         riderSumAssured: "",
      //         riderCoverageTerm: "",
      //         riderPremium: "",
      //         riderPremiumTerm: "",
      //         riderMultiplier: "",
      //         multiplier: {
      //           policyIllustration: "",
      //           sumAssuredType: "",
      //           sumAssured: "",
      //           premium: "",
      //           premiumTerm: "",
      //           policyTerm: "",
      //         },
      //       },
      //     ],
      //   },
      // ],

      // proposer: "",
      // lifeAssured: "",
      // needs: "",

      // product: {
      //   companyId: "",
      //   companyName: "",
      //   productCategoryId: "",
      //   productCategory: "",
      //   productId: "",
      //   productName: "",
      //   sumAssured: "",
      //   paymentFrequency: "",
      //   premium: "",
      //   premiumTerm: "",
      //   policyTerm: "",
      //   settlementMode: "",

      //   addMultiplier: "",
      //   multiplier: {
      //     policyIllustration: "",
      //     prodMultiplierBenefitType: "",
      //     prodMultiplierBenefit: "",
      //     prodMultiplierPremium: "",
      //     prodMultiplierPremiumTerm: "",
      //     prodMultiplierPolicyTerm: "",
      //   },

      //   riderOnly: "",
      //   riders: [
      //     {
      //       riderId: "",
      //       riderName: "",
      //       riderSumAssured: "",
      //       riderCoverageTerm: "",
      //       riderPremium: "",
      //       riderPremiumTerm: "",
      //       riderMultiplier: "",
      //       multiplier: {
      //         policyIllustration: "",
      //         sumAssuredType: "",
      //         sumAssured: "",
      //         premium: "",
      //         premiumTerm: "",
      //         policyTerm: "",
      //       },
      //     },
      //   ],
      // },
    },

    second: {
      proposer: "",
      lifeAssured: "",
      need: "",

      product: {
        companyId: "",
        companyName: "",
        productCategoryId: "",
        productCategory: "",
        productId: "",
        productName: "",
        sumAssured: "",
        paymentFrequency: "",
        premium: "",
        premiumTerm: "",
        policyTerm: "",
        settlementMode: "",

        addMultiplier: "",
        multiplier: {
          policyIllustration: "",
          sumAssuredType: "",
          sumAssured: "",
          premium: "",
          premiumTerm: "",
          policyTerm: "",
        },

        riderOnly: "",
        riders: [
          {
            riderId: "",
            riderName: "",
            riderSumAssured: "",
            riderPremium: "",
            riderPremiumTerm: "",
            riderMultiplier: "",
            multiplier: {
              policyIllustration: "",
              sumAssuredType: "",
              sumAssured: "",
              premium: "",
              premiumTerm: "",
              policyTerm: "",
            },
          },
        ],
      },
    },
  },

  reducers: {
    updateProductRecommendation: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "UPDATE_PROPOSER":
          state[payload.currApplicant].proposer = payload.data.proposer;
          break;

        case "UPDATE_LIST_ASSURED":
          state[payload.currApplicant].lifeAsured = payload.data.lifeAssured;
          break;

        case "UPDATE_NEEDS":
          state.needs = payload;
          break;

        case "UPDATE_COMPANY":
          state[payload.currApplicant].product.companyId = payload.data.companyId;
          state[payload.currApplicant].product.companyName = payload.data.companyName;
          break;

        case "UPDATE_PRODUCT_CATEGORY":
          state[payload.currApplicant].product.productCategoryId = payload.data.productCategoryId;
          state[payload.currApplicant].product.productCategory = payload.data.productCategory;
          break;

        case "UPDATE_PRODUCT":
          state[payload.currApplicant].product.productId = payload.data.productId;
          state[payload.currApplicant].product.productName = payload.data.productName;
          break;

        case "UPDATE_RIDER_ONLY":
          state[payload.currApplicant].riderOnly = payload.data.riderOnly;
          break;

        case "UPDATE_SUM_ASSURED":
          state[payload.currApplicant].sumAssured = payload.data.sumAssured;
          break;

        case "UPDATE_SUM_PREMIUM":
          state[payload.currApplicant].premium = payload.data.premium;
          break;

        case "UPDATE_SUM_PREMIUM_TERM":
          state[payload.currApplicant].premiumTerm = payload.data.premiumTerm;
          break;

        case "UPDATE_SUM_POLICY_TERM":
          state[payload.currApplicant].policyTerm = payload.data.policyTerm;
          break;

        case "UPDATE_PAYMENT_FREQUENCY":
          state[payload.currApplicant].paymentFrequency = payload.data.paymentFrequency;
          break;

        case "UPDATE_PAYMENT_SETTLEMENT_MODE":
          state[payload.currApplicant].settlementMode = payload.data.settlementMode;
          break;

        case "UPDATE_RIDER":
          state[payload.currApplicant].product.riders[0].riderId = payload.data.riderId;
          state[payload.currApplicant].product.riders[0].riderName = payload.data.riderName;
          break;

        case "UPDATE_RIDER_SUM_ASSURED":
          state[payload.currApplicant].product.riders[0].riderSumAssured = payload.data.riderSumAssured;
          break;

        case "UPDATE_RIDER_COVERAGE_TERM":
          state[payload.currApplicant].product.riders[0].riderCoverageTerm = payload.data.riderCoverageTerm;
          break;

        case "UPDATE_RIDER_PREMIUM":
          state[payload.currApplicant].product.riders[0].riderPremium = payload.data.riderPremium;
          break;

        case "UPDATE_RIDER_PREMIUM_TERM":
          state[payload.currApplicant].product.riders[0].riderPremiumTerm = payload.data.riderPremiumTerm;
          break;

        case "UPDATE_PRODCT_RECOMMENDATION_LIST":
          console.log(payload.data.prodRecommendationList.length);
          //state[payload.currApplicant].productRecommendations = payload.data.prodRecommendationList;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateProductRecommendation } = productRecommendationSlice.actions;

export default productRecommendationSlice.reducer;
